import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getCompanyMSDocumentListData } from './mockData'
import type { ICompanyMSDocument } from '~/types/document/models'

export const {
  getDocuments: getCompanyMSDocuments,
  postDocument: postCompanyMSDocument,
  patchDocument: patchCompanyMSDocument,
  deleteDocument: deleteCompanyMSDocument,
  handlers,
} = makeDocumentAPIs<ICompanyMSDocument>({
  apiPathEntityNamePrefix: 'companyms',
  getDocumentListDataFn: getCompanyMSDocumentListData,
})
